import { BldConsoleError } from '@/models';

export class WalletError extends BldConsoleError {}
